import React from 'react';
import backgroundVideo from '../assets/background.mp4';
import darkBgVideo from '../assets/darkbg.mp4';

const FADE_MS = 800;

const videoClassName =
  'absolute inset-0 min-w-full min-h-full w-full h-full object-cover object-center pointer-events-none transition-opacity ease-in-out';

interface DesktopBackgroundProps {
  isDarkMode: boolean;
}

/**
 * Light and dark wallpapers stacked with a crossfade on theme toggle.
 */
const DesktopBackground: React.FC<DesktopBackgroundProps> = ({ isDarkMode }) => (
  <div className="absolute inset-0 overflow-hidden">
    <video
      autoPlay
      loop
      muted
      playsInline
      className={videoClassName}
      style={{
        opacity: isDarkMode ? 0 : 1,
        transitionDuration: `${FADE_MS}ms`,
        zIndex: 0,
      }}
    >
      <source src={backgroundVideo} type="video/mp4" />
    </video>

    <video
      autoPlay
      loop
      muted
      playsInline
      className={videoClassName}
      style={{
        opacity: isDarkMode ? 1 : 0,
        filter: 'brightness(0.78)',
        transitionDuration: `${FADE_MS}ms`,
        zIndex: 1,
      }}
    >
      <source src={darkBgVideo} type="video/mp4" />
    </video>
  </div>
);

export default DesktopBackground;
